import React from 'react';

import { Telemetry } from '@videoblocks/kafka-rest-client';
import { Button } from '@videoblocks/storywind';

export interface NothingHeroProps {
  contentType: string;
  route: string;
}

export const NothingHero = ({ contentType, route }: NothingHeroProps) => {
  return (
    <div className="text-center bg-gray-100 my-14 maker-md:mx-36 mx-4 py-10 maker-md:px-28 px-4 rounded-xl w-auto max-w-fit">
      <p className="mb-6 text-2xl">
        <b>There is no {contentType} content in here yet!</b>
      </p>
      <p className="mb-6 text-xl">
        Add {contentType} content to this folder to organize your work.
      </p>
      <Button
        onClick={() => Telemetry.increment('favorite.empty-add-content')}
        href={route}
        className="inline-block text-black no-underline"
      >
        Add Content
      </Button>
    </div>
  );
};

export default NothingHero;
